// src/hooks/useSystemConfigWS.js
import { useEffect, useRef } from "react";
import { notify } from "../utils/notify";

// defaultWsUrl mirrors useNotificationsWS.js's own copy (see that file's
// doc comment for the full reasoning) — kept as a small duplicate rather
// than a shared import since each hook already deliberately owns its own
// connection lifecycle independently of the other.
function defaultWsUrl() {
  const scheme = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${scheme}//${window.location.host}/ws`;
}

export const useSystemConfigWS = (onUpdate) => {
  const wsRef = useRef(null);
  const onUpdateRef = useRef(onUpdate);

  // تحديث الـ Ref بدون إعادة تشغيل الـ Effect
  useEffect(() => {
    onUpdateRef.current = onUpdate;
  }, [onUpdate]);

  useEffect(() => {
    const wsUrl = process.env.REACT_APP_WS_URL || defaultWsUrl();

    // السيرفر بيرفض أي اتصال WebSocket من غير توكن صالح (راجع cmd/main.go)،
    // فلازم نبعت التوكن كـ query param وقت فتح الاتصال.
    const token = localStorage.getItem("token");
    if (!token) return;

    const separator = wsUrl.includes("?") ? "&" : "?";
    const socket = new WebSocket(`${wsUrl}${separator}token=${encodeURIComponent(token)}`);
    wsRef.current = socket;

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === "system_update" || data.type === "public_update") {
          if (onUpdateRef.current) onUpdateRef.current(data);
          notify.info(`Setting updated`);
        }
      } catch (err) {
        console.error("Invalid JSON from WS:", event.data);
      }
    };

    // معالج الخطأ - نجعله صامتاً قليلاً في الكونسول
    socket.onerror = () => {
      console.log("📡 WS Status: Checking connection...");
    };

    // --- [الحل السحري للتحذير] ---
    return () => {
      if (socket) {
        // نمسح كل المعالجات فوراً لمنع ظهور أخطاء أثناء الإغلاق
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;

        // لا نغلق الاتصال إلا إذا كان مفتوحاً فعلاً
        if (socket.readyState === WebSocket.OPEN) {
          socket.close();
        } else if (socket.readyState === WebSocket.CONNECTING) {
          // إذا كان لا يزال يحاول الاتصال، ننتظر حتى يفتح ثم نغلقه
          // هذا يمنع رسالة "closed before established"
          socket.onopen = () => socket.close();
        }
      }
    };
  }, []); // مصفوفة فارغة لضمان تشغيل واحد فقط
};
